namespace RioERP.Orders {
    export interface OrderProductsRow {
        Id?: number;
        OrderId?: number;
        ProductId?: number;
        OrderProduct?: number;
        OrderProductSpecificationId?: number[];
        Quantity?: number;
        Cost?: number;
        GrossAmount?: number;
        DiscountAmt?: number;
        FranchiseeId?: number;
        NetAmount?: number;
        NetAmountAfterFrDiscount?: number;
        TaxableAmount?: number;
        TaxAmount?: number;
        SerialKey?: string;
        HasPendrive?: boolean;
        HasBooks?: boolean;
        HasCourier?: boolean;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        IsActive?: boolean;
        InvoiceCompanyId?: number;
        FranchiseeDiscountAmount?: number;
        FranchiseeDiscountValue?: number;
        EFranchiseeDiscountType?: Web.Enums.FranchiseeDiscountType;
        EOpens?: Web.Enums.EOpens;
        EWatchTime?: Web.Enums.EWatchTime;
        EValidity?: Web.Enums.EValidity;
        EValidityType?: Web.Enums.EValidityType;
        ValidTill?: string;
        TotalAllowedDuration?: number;
        AllowedDevices?: string;
        AllowedDevice?: number[];
        IsLive?: boolean;
        EAccessStatus?: Web.Enums.AccessStatus;
        IsTemplateSerialKey?: boolean;
        Note?: string;
        ESerialkeyStatus?: Web.Enums.SerialkeyStatus;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        Rioplay8ProductCode?: string;
        Rioplay8ESubscriptionType?: Web.Enums.ESubscriptionType;
        Rioplay8EViewsType?: Rio.Enums.EViewType;
        Rioplay8EWatchTimetype?: Rio.Enums.EWatchTimetype;
        Rioplay8ViewsPerContent?: number;
        Rioplay8WatchTime?: number;
        Rioplay8AllowedDevices?: string;
        Rioplay8EDeviceRestrictionType?: Rio.Enums.EDeviceRestrictionType;
        Rioplay8DeviceCount?: number;
        Rioplay8SwitchCount?: number;
        Rioplay8ValidityInDays?: number;
        Rioplay8ValidDate?: string;
        Rioplay8TenantId?: string;
        ERioplayVersion?: Web.Enums.RioShieldVersion;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductProductName';
        export const localTextPrefix = 'Orders.OrderProducts';
        export const lookupKey = 'Orders.OrderProducts';

        export function getLookup(): Q.Lookup<OrderProductsRow> {
            return Q.getLookup<OrderProductsRow>('Orders.OrderProducts');
        }
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            ProductId = "ProductId",
            OrderProduct = "OrderProduct",
            OrderProductSpecificationId = "OrderProductSpecificationId",
            Quantity = "Quantity",
            Cost = "Cost",
            GrossAmount = "GrossAmount",
            DiscountAmt = "DiscountAmt",
            FranchiseeId = "FranchiseeId",
            NetAmount = "NetAmount",
            NetAmountAfterFrDiscount = "NetAmountAfterFrDiscount",
            TaxableAmount = "TaxableAmount",
            TaxAmount = "TaxAmount",
            SerialKey = "SerialKey",
            HasPendrive = "HasPendrive",
            HasBooks = "HasBooks",
            HasCourier = "HasCourier",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            IsActive = "IsActive",
            InvoiceCompanyId = "InvoiceCompanyId",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            ValidTill = "ValidTill",
            TotalAllowedDuration = "TotalAllowedDuration",
            AllowedDevices = "AllowedDevices",
            AllowedDevice = "AllowedDevice",
            IsLive = "IsLive",
            EAccessStatus = "EAccessStatus",
            IsTemplateSerialKey = "IsTemplateSerialKey",
            Note = "Note",
            ESerialkeyStatus = "ESerialkeyStatus",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            Rioplay8ProductCode = "Rioplay8ProductCode",
            Rioplay8ESubscriptionType = "Rioplay8ESubscriptionType",
            Rioplay8EViewsType = "Rioplay8EViewsType",
            Rioplay8EWatchTimetype = "Rioplay8EWatchTimetype",
            Rioplay8ViewsPerContent = "Rioplay8ViewsPerContent",
            Rioplay8WatchTime = "Rioplay8WatchTime",
            Rioplay8AllowedDevices = "Rioplay8AllowedDevices",
            Rioplay8EDeviceRestrictionType = "Rioplay8EDeviceRestrictionType",
            Rioplay8DeviceCount = "Rioplay8DeviceCount",
            Rioplay8SwitchCount = "Rioplay8SwitchCount",
            Rioplay8ValidityInDays = "Rioplay8ValidityInDays",
            Rioplay8ValidDate = "Rioplay8ValidDate",
            Rioplay8TenantId = "Rioplay8TenantId",
            ERioplayVersion = "ERioplayVersion",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
